import type { Employee } from '@makemydeal/dr-shared-types';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { SALES_MANAGER } from '@makemydeal/dr-dash-types';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { getBridgeId } from '../selectors/bridgeUserSelectors';
import { getSalesManager } from '../selectors/employeeDetailsSelectors';

export const willStampLoggedInUserAsSalesManager = (state: StateTree): boolean =>
    !(featureToggleSelectors.isDontClobberSalesManagerOnSaveEnabled(state) && getSalesManager(state));

export const buildEmployeeDetails = (state: StateTree): Employee[] => {
    if (!willStampLoggedInUserAsSalesManager(state)) {
        return [];
    }

    return [
        {
            employeeRole: SALES_MANAGER,
            bridgeId: getBridgeId(state)
        }
    ];
};
